import { render } from "./modalAutomatizaciones.vue?vue&type=template&id=5dff5f40&scoped=true"
import script from "./modalAutomatizaciones.vue?vue&type=script&lang=js"
export * from "./modalAutomatizaciones.vue?vue&type=script&lang=js"

import "./modalAutomatizaciones.vue?vue&type=style&index=0&id=5dff5f40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dff5f40"]])

export default __exports__